import { render, staticRenderFns } from "./bankList.vue?vue&type=template&id=5cfed4f8&scoped=true"
import script from "./bankList.vue?vue&type=script&lang=js"
export * from "./bankList.vue?vue&type=script&lang=js"
import style0 from "./bankList.vue?vue&type=style&index=0&id=5cfed4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfed4f8",
  null
  
)

export default component.exports